import React from 'react'
import { array, string } from 'prop-types'

class DiscountVoucher extends React.Component {
  render () {
    const { id, functionParams } = this.props
    if (!functionParams || functionParams.length < 3) return null
    const discountAmount = functionParams[0]
    const voucherTitle = functionParams[1]
    const voucherLink = functionParams[2]
    return (
      <div id={id} className='discountCodeBox'>
        <p className='discountAmount'>{ discountAmount }% OFF*</p>
        <p className='voucherTitle'>{ voucherTitle }</p>
        <a className='voucherLink' href={voucherLink}>Apply discount</a>
      </div>
    )
  }
}

DiscountVoucher.propTypes = {
  functionParams: array.isRequired,
  id: string.isRequired
}

export default DiscountVoucher



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/discountVoucher.jsx